module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-dots-fill-893b368c.svg";